import React from 'react'
import { Link } from 'react-router-dom'
import { useI18n } from '../state/I18nContext'
import { useCart } from '../state/CartContext'

const Cart: React.FC = () => {
  const { state, remove, update, total } = useCart()
  const { locale, t } = useI18n()
  const items = state.items

  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold">{t.cartPage.title}</h1>
      {items.length === 0 ? (
        <div className="mt-6 rounded-xl border border-neutral-200 p-6 bg-white">
          <p className="text-neutral-700">{t.cartPage.empty}</p>
          <Link
            to={`/${locale}/taste`}
            className="inline-block mt-4 rounded-lg bg-amber-600 text-white px-5 py-3 font-semibold hover:bg-amber-700"
          >
            {t.cartPage.browseCatalog}
          </Link>
        </div>
      ) : (
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          <div className="md:col-span-2 space-y-4">
            {items.map(i => (
              <div key={i.id} className="flex items-center gap-4 rounded-xl border border-neutral-200 p-4 bg-white">
                <img src={i.image} alt={i.name} className="w-20 h-20 object-cover rounded-lg" />
                <div className="flex-1">
                  <h3 className="font-semibold">{i.name}</h3>
                  <p className="text-sm text-neutral-600">€ {i.price.toFixed(2)}</p>
                  <div className="mt-2 flex items-center gap-2">
                    <label className="text-sm text-neutral-700">{t.cartPage.qty}</label>
                    <input
                      type="number"
                      className="w-20 rounded-lg border border-neutral-300 px-2 py-1"
                      value={i.qty}
                      min={1}
                      onChange={e => update(i.id, Math.max(1, Number(e.target.value)))}
                    />
                  </div>
                </div>
                <button className="text-red-600 hover:underline" onClick={() => remove(i.id)}>{t.cartPage.remove}</button>
              </div>
            ))}
          </div>
          <div className="rounded-xl border border-neutral-200 p-6 bg-white">
            <h2 className="font-semibold">{t.cartPage.orderSummary}</h2>
            <div className="mt-3 flex items-center justify-between">
              <span>{t.cartPage.total}</span>
              <span className="font-bold text-amber-700">€ {total.toFixed(2)}</span>
            </div>
            <Link to={`/${locale}/checkout`} className="mt-6 block text-center rounded-lg bg-amber-600 text-white px-5 py-3 font-semibold hover:bg-amber-700">{t.cartPage.proceedToCheckout}</Link>
          </div>
        </div>
      )}
    </section>
  )
}

export default Cart
